var $ = require('jquery'),
  requireLogin = require('widgets/requireLogin'),
  voteCurrentGame = require('./voteCurrentGame'),
  renderDownload = require('./renderDownload'),
  cherishCurrentGame = require('./cherishCurrentGame')

$(function () {
  $('.header').on('click', '.js-vote', requireLogin(voteCurrentGame, 'vote'))
  $('.header').on('click', '.js-cherish', requireLogin(cherishCurrentGame))
  renderDownload($('.header'))
})

